import { render, staticRenderFns } from "./ProductPrivateSpaceDetails.vue?vue&type=template&id=01d578b8&"
import script from "./ProductPrivateSpaceDetails.vue?vue&type=script&lang=ts&"
export * from "./ProductPrivateSpaceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports